import { createContext } from 'react'

import { ConfigureState } from './interface'

export const SchemaFormConfigureContext = createContext<ConfigureState>({
  placeholder: '-'
})

export const SchemaFormConfigureProvider = SchemaFormConfigureContext.Provider
